import React from 'react';
import OrgChartNodeCard from './OrgChartNodeCard';

function nodeCardProps(node, expandedNodes, onToggle, onNavigate) {
  const children = node.children || [];
  return {
    node,
    hasChildren: children.length > 0,
    isExpanded: expandedNodes.has(node.id),
    onToggle,
    onNavigate,
    childCount: children.length,
  };
}

export function buildTopDownTreeNode(node, expandedNodes, onToggle, onNavigate) {
  const props = nodeCardProps(node, expandedNodes, onToggle, onNavigate);
  const children = node.children || [];
  const childList = props.hasChildren && props.isExpanded
    ? React.createElement(
        'ul',
        null,
        children.map((child) => buildTopDownTreeNode(child, expandedNodes, onToggle, onNavigate)),
      )
    : null;

  return React.createElement(
    'li',
    { key: node.id, 'data-testid': `org-chart-node-${node.id}` },
    React.createElement(OrgChartNodeCard, props),
    childList,
  );
}

export function buildFlowTreeNode(node, expandedNodes, onToggle, onNavigate) {
  const props = nodeCardProps(node, expandedNodes, onToggle, onNavigate);
  const children = node.children || [];

  if (!props.hasChildren || !props.isExpanded) {
    return React.createElement(
      'div',
      { key: node.id, className: 'org-flow-branch', 'data-testid': `org-chart-node-${node.id}` },
      React.createElement(OrgChartNodeCard, props),
    );
  }

  return React.createElement(
    'div',
    { key: node.id, className: 'org-flow-branch', 'data-testid': `org-chart-node-${node.id}` },
    React.createElement(OrgChartNodeCard, props),
    React.createElement(
      'div',
      { className: 'org-flow-connector-col' },
      React.createElement('div', { className: 'h-line' }),
      React.createElement('div', { className: 'v-line' }),
    ),
    React.createElement(
      'div',
      { className: 'org-flow-children' },
      children.map((child) => buildFlowTreeNode(child, expandedNodes, onToggle, onNavigate)),
    ),
  );
}
